import { Box, Skeleton } from '@mui/material';

const PageSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box
        sx={{
          width: '100%',
          height: 64,
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          display: 'flex',
          alignItems: 'center',
          px: 3,
          position: 'fixed',
          top: 0,
          bgcolor: 'background.paper',
          zIndex: 1100,
        }}
      >
        <Skeleton variant='rounded' width={120} height={28} sx={{ borderRadius: 1 }} />
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton variant='circular' width={36} height={36} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          mt: 8,
          px: { xs: 2, sm: 3 },
        }}
      >
        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            width: 240,
            mr: 3,
            flexShrink: 0,
          }}
        >
          <Skeleton variant='rounded' width={180} height={40} sx={{ mb: 2 }} />
          <Skeleton variant='rounded' width={200} height={40} sx={{ mb: 2 }} />
          <Skeleton variant='rounded' width={160} height={40} sx={{ mb: 2 }} />
          <Skeleton variant='rounded' width={190} height={40} sx={{ mb: 2 }} />
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ mb: 4 }}>
            <Skeleton variant='rounded' width={240} height={48} sx={{ mb: 1 }} />
            <Skeleton variant='rounded' width='70%' height={24} />
          </Box>

          <Box sx={{ mb: 4 }}>
            <Skeleton variant='rounded' width='100%' height={220} />
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
            <Skeleton variant='rounded' width='100%' height={180} />
            <Skeleton variant='rounded' width='100%' height={180} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PageSkeleton;
